export default __webpack_public_path__ + "static/media/pagefive.50ebb174.txt";